import { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';

import * as routes from 'router/routes';
import { USER_PERMISSIONS } from 'constants/userPermissions';
import { useCurrentUserInfo } from 'hooks/useCurrentUserInfo';
import { useMatchPathParams } from 'hooks/useMatchPathParams';
import { useChildRouteId } from 'hooks/useChildRouteId';
import { FullScreenLoader } from 'layouts';

const DEFAULT_ALLOWED_PERMISSIONS = [USER_PERMISSIONS.ORGANISATION_ADMIN, USER_PERMISSIONS.SUPER_ADMIN];

const AccessControlRoute = ({ allow = DEFAULT_ALLOWED_PERMISSIONS }) => {
  const { organisationId } = useMatchPathParams();
  const { userPermissions } = useCurrentUserInfo(organisationId);
  const childRouteId = useChildRouteId();

  if (!userPermissions) {
    return <FullScreenLoader />;
  }

  if (!allow.includes(userPermissions)) {
    return <Navigate replace to={routes.home} />;
  }

  return (
    <Suspense key={childRouteId} fallback={<FullScreenLoader />}>
      <Outlet />
    </Suspense>
  );
};

AccessControlRoute.propTypes = {
  allow: PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_PERMISSIONS))),
};

export default AccessControlRoute;
